import React, { useState } from "react";
import { injectIntl } from "react-intl";
import {
  ActionBar,
  Details,
  DetailsHeaderItem,
  DetailsItem,
  DetailsPicture,
  PictureGallery,
  Heading,
  Container,
  Column,
  Row,
  Loader,
  backendShape,
  intlShape,
  notifierShape,
  ContextualHelp,
  withBackend,
  withApi,
  apiShape,
  withNotifier,
  ActionBarButtons,
  CreateActionButton,
} from "lcm-iot-commons";
import { OpcUaServerCertificatesList } from "./OpcUaServerCertificatesList";
import {
  opcUaServerIconClassName,
  opcUaServerStatusIconClassName,
} from "../../utils/statusUtils";
import OpcUaServerWhitelist from "./OpcUaServerWhitelist";

type Props = {
  intl: intlShape;
  match: {
    params?: {
      subscription_id?: string;
      id?: string;
    };
  };
  api: apiShape;
  notifier: notifierShape;
  backend: backendShape;
};

export function OpcUaServerDetails({
  intl,
  match,
  notifier,
  api,
  backend,
}: Props) {
  const [opcUaServer, setOpcUaServer] = useState();
  const [accessRights, setAccessRights] = useState();

  React.useEffect(() => {
    const loadData = async () => {
      try {
        const subscription = await api.get(
          `/api_subscriptions/${
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            match.params.subscription_id
          }`,
        );
        // eslint-disable-next-line camelcase
        const accessRightsResponse = await api.get(
          "/users/current/access_rights",
          {
            permitable_type: "ClientApplication",
            permitable_id: subscription?.client_application.id,
          },
        );
        setAccessRights({
          // @ts-expect-error TS(2345) FIXME: Argument of type '{ canUpdate: any; }' is not assi... Remove this comment to see the full error message
          canUpdate: accessRightsResponse.can_update,
        });
        setOpcUaServer(
          await backend.get(
            `/api_subscriptions/${
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              match.params.subscription_id
            }/opc_ua_servers/${
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              match.params.id
            }`,
          ),
        );
      } catch (error) {
        notifier.showError(backend.translateError(error));
      }
    };
    loadData();
  }, [match]);

  return (
    <Loader loading={!opcUaServer}>
      <Container>
        <Row>
          <Column>
            <ActionBar>
              <Heading
                id="details-heading"
                title={intl.formatMessage({
                  id: "opc_ua_server_details.header",
                })}
              />
            </ActionBar>
          </Column>
        </Row>
        {opcUaServer ? (
          <Details>
            <Row>
              <Column>
                <DetailsPicture>
                  <PictureGallery placeholder={opcUaServerIconClassName()} />
                </DetailsPicture>
                <DetailsHeaderItem
                  // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
                  intl={intl}
                  id="opc-ua-server-hostname"
                  translationKey="label.opc_ua_connection_url"
                  value={`opc.tcp://${(opcUaServer as $TSFixMe).hostname}:62541/Server`}
                  breakValue
                />
              </Column>
            </Row>
            <Row>
              <Column>
                <DetailsItem
                  // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; icon: string;... Remove this comment to see the full error message
                  intl={intl}
                  id="opc-ua-server-status"
                  icon={opcUaServerStatusIconClassName(
                    (opcUaServer as $TSFixMe).status,
                  )}
                  translationKey="label.status"
                  value={intl.formatMessage({
                    id: `enum.opc_ua_server.${(opcUaServer as $TSFixMe).status}`,
                  })}
                />
              </Column>
            </Row>
            <div
              id="client_certificates-list"
              className="row space-before space-after"
            >
              <div className="col-md-12">
                <ActionBar>
                  <Heading
                    id="client-certificates"
                    title={intl.formatMessage({
                      id: "opc_ua_server_details.client_certificates",
                    })}
                    level={2}
                  >
                    <ContextualHelp
                      title={intl.formatMessage({
                        id: "opc_ua_server_details.client_certificates",
                      })}
                    >
                      <p>
                        {intl.formatMessage({
                          id: "client_certificate.help_1",
                        })}
                      </p>
                      <p>
                        {intl.formatMessage({
                          id: "client_certificate.help_2",
                        })}
                      </p>
                      <p>
                        {intl.formatMessage({
                          id: "client_certificate.help_3",
                        })}
                      </p>
                    </ContextualHelp>
                  </Heading>
                </ActionBar>
                <OpcUaServerCertificatesList
                  type="client"
                  notifier={notifier}
                  intl={intl}
                  backend={backend}
                  opcUaServer={opcUaServer}
                  accessRights={accessRights}
                />
              </div>
            </div>
            <div
              id="ca_certificates-list"
              className="row space-before space-after"
            >
              <div className="col-md-12">
                <ActionBar>
                  <Heading
                    id="ca-certificates"
                    title={intl.formatMessage({
                      id: "opc_ua_server_details.ca_certificates",
                    })}
                    level={2}
                  >
                    <ContextualHelp
                      title={intl.formatMessage({
                        id: "opc_ua_server_details.ca_certificates",
                      })}
                    >
                      <p>
                        {intl.formatMessage({ id: "ca_certificate.help_1" })}
                      </p>
                      <p>
                        {intl.formatMessage({ id: "ca_certificate.help_2" })}
                      </p>
                      <p>
                        {intl.formatMessage({ id: "ca_certificate.help_3" })}
                      </p>
                    </ContextualHelp>
                  </Heading>
                  <ActionBarButtons>
                    <div>
                      <CreateActionButton
                        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: boolean; target: str... Remove this comment to see the full error message
                        id="create-ca-certificate"
                        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                        disabled={!accessRights.canUpdate}
                        target={`/subscriptions/connect/${(opcUaServer as $TSFixMe).subscription_id}/opc_ua_servers/${(opcUaServer as $TSFixMe).id}/upload_ca_certificate`}
                      />
                    </div>
                  </ActionBarButtons>
                </ActionBar>
                <OpcUaServerCertificatesList
                  type="ca"
                  notifier={notifier}
                  intl={intl}
                  backend={backend}
                  opcUaServer={opcUaServer}
                  accessRights={accessRights}
                />
              </div>
            </div>
            <div id="whitelist" className="row space-before space-after">
              <div className="col-md-12">
                <ActionBar>
                  <Heading
                    id="whitelist-header"
                    title={intl.formatMessage({
                      id: "opc_ua_server_details.whitelist.header",
                    })}
                    level={2}
                  >
                    <ContextualHelp
                      title={intl.formatMessage({
                        id: "opc_ua_server_details.whitelist.header",
                      })}
                    >
                      <p>{intl.formatMessage({ id: "whitelist.help_1" })}</p>
                      <p>{intl.formatMessage({ id: "whitelist.help_2" })}</p>
                      <p>{intl.formatMessage({ id: "whitelist.help_3" })}</p>
                    </ContextualHelp>
                  </Heading>
                </ActionBar>
                <OpcUaServerWhitelist
                  opcUaServer={opcUaServer}
                  // @ts-expect-error TS(2322) FIXME: Type 'undefined' is not assignable to type 'access... Remove this comment to see the full error message
                  accessRights={accessRights}
                />
              </div>
            </div>
          </Details>
        ) : null}
      </Container>
    </Loader>
  );
}

export default withNotifier(
  withApi(withBackend(injectIntl(OpcUaServerDetails))),
);
